import { Component } from '@angular/core';
import { header } from './config/surgeries-private.config';
import { SurgeryPrivateService } from '../../services/surgery/surgery.pr.service';

@Component({
  selector: 'app-surgeries-private',
  templateUrl: './surgeries-private.component.html',
  styleUrl: './surgeries-private.component.scss'
})
export class SurgeriesPrivateComponent {
  constructor(private surgeryService: SurgeryPrivateService) {}

  ngOnInit() {
    this.surgeryService.init();
  }

  getPageHeader(): string {
    return header;
  }
}
